import React from "react"
import HostMinigame from "../space-game/index"

const SpaceGamePage = () => {
  React.useEffect(() => {
    console.log("Space Game Page Loaded")
  }, [])

  return (
    <div>
      <HostMinigame />
    </div>
  )
}

export default SpaceGamePage
